const o = () => {
  const r = new SharedWorker(
    new URL(
      /* @vite-ignore */
      "./assets/worker-DFqp3K5a.js",
      import.meta.url
    ),
    { type: "module" }
  );
  return r.onerror = (e) => console.error(e), r.port.start(), r;
};
export {
  o as initializeWorker
};
//# sourceMappingURL=zudoku.openapi-worker.js.map
